module.exports = "/_next/static/images/first-home_lower-deposit-mobile-1b3550e8f5a01b2b7edf6e6e5375cea1.svg";